module.exports = __webpack_public_path__ + "img/logo.152b83a7.svg";